import { ActionTooltip, Kbd } from './Kbd'

interface SelectionActionBarProps {
  count: number
  onClear: () => void
  onArchive: () => void
  onStar: () => void
  onTag: () => void
  onMarkRead: () => void
  isArchiveView: boolean
  className?: string
}

export default function SelectionActionBar({
  count,
  onClear,
  onArchive,
  onStar,
  onTag,
  onMarkRead,
  isArchiveView,
  className,
}: SelectionActionBarProps) {
  return (
    <div className={`flex items-center justify-between border-b border-blue-200 bg-blue-50 px-4 py-2.5 ${className || ''}`}>
      <div className="flex items-center gap-2">
        <button onClick={onClear} aria-label="Clear selection" className="flex h-5 w-5 items-center justify-center rounded bg-blue-500 text-white">
          <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <polyline points="20 6 9 17 4 12" />
          </svg>
        </button>
        <span className="text-xs font-medium text-blue-700">{count} selected</span>
        <button onClick={onClear} className="text-[11px] text-blue-500 hover:text-blue-600">Clear</button>
      </div>
      <div className="flex items-center gap-1">
        <ActionTooltip label={isArchiveView ? 'Unarchive' : 'Archive'} shortcut={<Kbd>E</Kbd>}>
          <button onClick={onArchive} aria-label={isArchiveView ? 'Unarchive selected' : 'Archive selected'} className="flex h-7 w-7 items-center justify-center rounded-md text-zinc-500 hover:bg-blue-100 hover:text-zinc-700">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <polyline points="21 8 21 21 3 21 3 8" /><rect x="1" y="3" width="22" height="5" /><line x1="10" y1="12" x2="14" y2="12" />
            </svg>
          </button>
        </ActionTooltip>
        <ActionTooltip label="Star" shortcut={<Kbd>S</Kbd>}>
          <button onClick={onStar} aria-label="Star selected" className="flex h-7 w-7 items-center justify-center rounded-md text-zinc-500 hover:bg-blue-100 hover:text-zinc-700">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
            </svg>
          </button>
        </ActionTooltip>
        <ActionTooltip label="Tag" shortcut={<Kbd>T</Kbd>}>
          <button onClick={onTag} aria-label="Tag selected" className="flex h-7 w-7 items-center justify-center rounded-md text-zinc-500 hover:bg-blue-100 hover:text-zinc-700">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z" /><line x1="7" y1="7" x2="7.01" y2="7" />
            </svg>
          </button>
        </ActionTooltip>
        <ActionTooltip label="Mark read/unread" shortcut={<Kbd>U</Kbd>}>
          <button onClick={onMarkRead} aria-label="Toggle read/unread" className="flex h-7 w-7 items-center justify-center rounded-md text-zinc-500 hover:bg-blue-100 hover:text-zinc-700">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <path d="M22 12h-6l-2 3h-4l-2-3H2" /><path d="M5.45 5.11L2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z" />
            </svg>
          </button>
        </ActionTooltip>
      </div>
    </div>
  )
}
